import { USER_ROLE } from '@/constants/user'

export default ({
  computed: {
    $authUser () {
      return this.$store.getters.user
    },
    $isCCUser () {
      if (this.$authUser.status === USER_ROLE.CASH_CONNECT) {
        return true
      } 
    },
    $isChangeOrderGroup () {
      console.log('######## CHANGE ORDER ALLOWED GROUP ', this.$authUser)
      //if (status === 'admin' || status === 'e2c' || usergroup === 'JAKES 58' || usergroup === 'CTown Dime' || usergroup === 'Lombardis' || usergroup === 'Mitchelll' || usergroup === 'aegvision' || currentUser.email === 'ECSofWA1543@aegvision.com' || currentUser.email === 'mbui@aegvision.com' || currentUser.email === 'mitchellaegtest@aegvision.com') {
      if (this.$authUser.status === USER_ROLE.PLATFORM_ADMIN || this.$authUser.status === USER_ROLE.TOP_ADMIN) {
        return true
      } 
      let changeOrderAllowedGroups = ['JAKES 58', 'CTown Dime', 'Lombardis', 'Mitchelll', 'aegvision', 'True Pinless', 'F&J Master Sales Corp', 'Dime Branches', 'Broadway Financial','Peter Luger Dime']
      console.log('is this user is in group ', this.$authUser.group, changeOrderAllowedGroups)
      if (changeOrderAllowedGroups.includes(this.$authUser.group)) {
        console.log('100% IN CHANGE ORDER GROUP LIST')

        return true
      } 
      console.log('NOT IN CHANGE ORDER GROUP LIST')
      return false

      //return this.$authUser.status === 'Active'
    },
    $isFIUser () {
      // if (this.$authUser.status === 'Active' || this.$authUser.status === 'Admin') {
      //   return true
      // } 
      return true

      //return this.$authUser.status === 'Active'
    },
    $isActiveUser () {
      // if (this.$authUser.status === 'Active' || this.$authUser.status === 'Admin') {
      //   return true
      // } 
      return true

      //return this.$authUser.status === 'Active'
    },

    $isPlatformAdmin () {
      console.log('USER HELPER DATA PLATFORM ADMIN ', this.$authUser)
      if (this.$authUser.status === USER_ROLE.PLATFORM_ADMIN || this.$authUser.status === USER_ROLE.TOP_ADMIN) {
        console.log('user is admin in helper ', this.$authUser.status)
        return true
      }
      return this.$authUser.status === USER_ROLE.PLATFORM_ADMIN
    },
  },
})
